// extracted by mini-css-extract-plugin
module.exports = {"container":"PolicyStatus__container","hr":"PolicyStatus__hr","articleContainer":"PolicyStatus__articleContainer","card":"PolicyStatus__card"};